import { render } from "./VisionZeroView.vue?vue&type=template&id=87d42d64&scoped=true"
import script from "./VisionZeroView.vue?vue&type=script&lang=js"
export * from "./VisionZeroView.vue?vue&type=script&lang=js"

import "./VisionZeroView.vue?vue&type=style&index=0&id=87d42d64&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87d42d64"]])

export default __exports__